/* global CriteriaHelper */
import * as React from 'react';

// Hooks
import { useCriteriaStorePredicate } from '../../../../../../../state/criteria/hooks/useCriteriaStorePredicate';

// Types
import { ruleEditorViewPartCommonProps } from '../../types';

export const GenericPartLabelRenderer = ({ id, ...props }) => {
    const part = useCriteriaStorePredicate(id);
    const partClassification = part ? CriteriaHelper.getPartClassificationKey(part) : null;

    return (
        <span style={{ position: 'relative', zIndex: 1 }}>
            {typeof CriteriaHelper.partTypes[partClassification].label === 'function'
                ? CriteriaHelper.partTypes[partClassification].label(part)
                : CriteriaHelper.partTypes[partClassification].label}
        </span>
    );
};

export default GenericPartLabelRenderer;

GenericPartLabelRenderer.propTypes = {
    ...ruleEditorViewPartCommonProps
};
